export default (value) => {
  if (value == null) {
    return 'n/a'
  } else {
    return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(value) + '%'
  }
}
